import { render, staticRenderFns } from "./WillBeneficiariesDrugsPeople.vue?vue&type=template&id=5a3f2860"
import script from "./WillBeneficiariesDrugsPeople.vue?vue&type=script&lang=js"
export * from "./WillBeneficiariesDrugsPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports